import { PersonCheckOutlined, SyncOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import { type ComponentPropsWithoutRef, forwardRef } from "react"

import { InvoiceAs400SyncIndicatorVariant } from "../types/invoiceAs400Sync"

interface InvoiceAs400SyncIconProps
  extends Omit<ComponentPropsWithoutRef<typeof SyncOutlined>, "className" | "fontSize"> {
  variant: InvoiceAs400SyncIndicatorVariant
  "data-testid"?: string
}

const VARIANT_TO_TEST_ID: Record<InvoiceAs400SyncIndicatorVariant, string> = {
  [InvoiceAs400SyncIndicatorVariant.Pending]: "invoices.as400-sync-indicator.pending-icon",
  [InvoiceAs400SyncIndicatorVariant.Failed]: "invoices.as400-sync-indicator.failed-icon",
  [InvoiceAs400SyncIndicatorVariant.Resolved]: "invoices.as400-sync-indicator.manually-resolved-icon",
}

// One icon per sync state, shared by every invoice screen that shows it. It forwards its ref and props so MUI's Tooltip
// can attach to it; a screen can pass its own `data-testid`.
export const InvoiceAs400SyncIcon = forwardRef<SVGSVGElement, InvoiceAs400SyncIconProps>(
  ({ variant, "data-testid": testId = VARIANT_TO_TEST_ID[variant], ...iconProps }, ref) => {
    switch (variant) {
      case InvoiceAs400SyncIndicatorVariant.Pending:
        return <SyncOutlined {...iconProps} ref={ref} className='text-gray-600' fontSize='small' data-testid={testId} />
      case InvoiceAs400SyncIndicatorVariant.Failed:
        return (
          <WarningOutlined
            {...iconProps}
            ref={ref}
            className='text-secondary-600'
            fontSize='small'
            data-testid={testId}
          />
        )
      // AK-5383 AC3: the green User Check icon marks an exception a user reconciled by hand.
      case InvoiceAs400SyncIndicatorVariant.Resolved:
        return (
          <PersonCheckOutlined
            {...iconProps}
            ref={ref}
            className='text-tertiary-green-500'
            fontSize='small'
            data-testid={testId}
          />
        )
    }
  }
)

InvoiceAs400SyncIcon.displayName = "InvoiceAs400SyncIcon"
